import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (params = {}) {
  try {
    return await $apiFetch(API_ENDPOINTS.STOCK_ITEMS, {
      method: 'GET',
      params
    });
  } catch (error) {
    sentryCaptureEvent({
      message: 'stock-items-load',
      level: 'error',
      extra: { error }
    });
  }

  return null;
}
